module.exports = __webpack_public_path__ + "img/logo-fluid.b8a9d527.png";